import { render, staticRenderFns } from "./WallpaperMenu.vue?vue&type=template&id=9bc372ac&scoped=true&"
import script from "./WallpaperMenu.vue?vue&type=script&lang=js&"
export * from "./WallpaperMenu.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperMenu.vue?vue&type=style&index=0&id=9bc372ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc372ac",
  null
  
)

export default component.exports